const ACCESS_TOKEN_COOKIE = 'access-token';

export { ACCESS_TOKEN_COOKIE };
